import { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import { useLoading } from '../../components/LoadingProvider';
import { showError } from '../../utils/toast';
import { getPublicImgUrl } from '../../utils/common';

function SpecializationDoctorList() {
    const { slug } = useParams();
    const navigate = useNavigate();
    document.title = `Varosa - Doctor List`;
    const { setIsLoading } = useLoading();
    const [doctorList, setDoctorList] = useState([]);
    const [specialization, setSpecialization] = useState({});
    useEffect(() => {
        setIsLoading(true);
        api.get(`/specialization/${slug}/doctors`).then((response) => {
            if (response?.data?.result === 'success') {
                setDoctorList(response?.data?.data?.doctors || []);
                setSpecialization(response?.data?.data?.specialization || {});
                document.title = `Varosa - ${specialization?.name || slug.charAt(0).toUpperCase() + slug.slice(1)} Doctor List`;
            }else if (response?.data?.result === 'failed') {
                showError(response?.data?.message);
                if(response?.data?.errors){
                    response?.data?.errors.forEach((item, index, arr) => {
                        showError(item);
                    });
                }
            } else {
                showError(response.data?.message || 'An error occurred');
            }
        }).catch((error) => {
            showError(error.message);
        }).finally(() => {
            setIsLoading(false);
        });
    }, [slug]);
    return (
        <>
            {/* Header Start */}
            <div className="container-fluid bg-breadcrumb">
                <div className="container text-center py-5" style={{maxWidth: '900px'}}>
                    <h3 className="text-white display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">{specialization?.name || slug.charAt(0).toUpperCase() + slug.slice(1)} Doctor List</h3>
                    <ol className="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item"><Link to="/specialization/all">Specialization</Link></li>
                        <li className="breadcrumb-item active text-primary">{specialization?.name || slug.charAt(0).toUpperCase() + slug.slice(1)}</li>
                    </ol>
                </div>
            </div>
            {/* Header End */}

            <div className="container-fluid team py-5">
                <div className="container py-5">
                    <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h4 className="sub-title px-3 mb-0">{specialization?.name || slug.charAt(0).toUpperCase() + slug.slice(1)} Doctor List</h4>
                        </div>
                    </div>
                    {doctorList.length > 0 ? (
                        <div className="row g-4 mt-2 justify-content-center">
                            {doctorList.map((doctor) => (
                            <div className="col-md-4 col-sm-6 col-xs-12 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="team-item rounded">
                                    <div className="team-img rounded-top h-100 border border-primary border-bottom-0 pt-3">
                                        <img src={doctor.profile_picture || (getPublicImgUrl()+'/doctor_2785482.png')} className="img-fluid rounded-top w-100" style={{ maxHeight: '250px', objectFit: 'contain' }} alt="" />
                                    </div>
                                    <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                        <h5 className="mb-2">{doctor.name}</h5>
                                        {doctor.qualification && (<p className="mb-3">
                                            <b>Qualification: </b> 
                                            {doctor.qualification?.length > 100 ? doctor.qualification.slice(0, 100) : doctor.qualification}
                                            {doctor.qualification?.length > 100 ? (
                                                <>
                                                <span className={`d-none rest-qualification-${doctor.id}`}>{doctor.qualification.slice(100)}</span>
                                                &nbsp;&nbsp;
                                                <button onClick={(e) => { 
                                                    e.preventDefault();
                                                    var elements = document.getElementsByClassName(`rest-qualification-${doctor.id}`);
                                                    if(elements.length > 0){
                                                        if(elements[0].classList.contains("d-none")){
                                                            elements[0].classList.remove("d-none");
                                                            e.target.textContent = 'Read Less';
                                                        }else{
                                                            elements[0].classList.add("d-none");
                                                            e.target.textContent = 'Read More';
                                                        }
                                                    }
                                                }} className="btn btn-outline-success btn-sm ml-3">Read More</button>
                                                </>
                                            ) : ''}
                                        </p>)}
                                        {doctor.bio && (<p className="mb-3">
                                            <b>Doctor Bio:</b> {doctor.bio?.length > 100 ? doctor.bio.slice(0, 100) : doctor.bio}
                                            {doctor.bio?.length > 100 ? (
                                                <>
                                                <span className={`d-none rest-bio-${doctor.id}`}>{doctor.bio.slice(100)}</span>
                                                &nbsp;&nbsp;
                                                <button onClick={(e) => { 
                                                    e.preventDefault();
                                                    var elements = document.getElementsByClassName(`rest-bio-${doctor.id}`);
                                                    if(elements.length > 0){
                                                        if(elements[0].classList.contains("d-none")){
                                                            elements[0].classList.remove("d-none");
                                                            e.target.textContent = 'Read Less';
                                                        }else{
                                                            elements[0].classList.add("d-none");
                                                            e.target.textContent = 'Read More';
                                                        }
                                                    }
                                                }} className="btn btn-outline-success btn-sm ml-3">Read More</button>
                                                </>
                                            ) : ''}
                                        </p>)}
                                        <p className="mb-3"><b>Specializations:</b> {doctor.specializations.map((specialization) => (
                                            <span key={specialization} className="badge bg-primary me-1">{specialization}</span>
                                        ))}</p>
                                        <p className="mb-3"><b>Consultation Fees: <i>&#8377;{doctor.consultation_fee}</i></b></p>
                                        <hr />
                                        <button onClick={(e) => { 
                                            e.preventDefault();
                                            navigate(`/dashboard/patient/appointment/book/?t=${doctor.name}&d=${doctor.id}`)
                                        }} className="btn btn-primary text-white">Book Appointment</button>
                                    </div>
                                </div>
                            </div>))}
                        </div>
                    ) : (
                        <div className="row g-4 justify-content-center">
                            <div className="col-md-6 text-center col-sm-12">
                                <h5 className="mb-1 mt-1 py-3 text-center border border-primary rounded">
                                    <i className="fas fa-exclamation-circle me-2"></i>
                                    No Doctor Found
                                </h5>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default SpecializationDoctorList;